module.exports = __webpack_public_path__ + "static/media/LVFrame8.20156bff.png";